import { TrendingUp, TrendingDown } from "lucide-react";

export function GainBadge({ currentMc, spawnMc, priceChange24h }: { currentMc?: number | null; spawnMc?: number | null; priceChange24h?: number | null }) {
  let pct = priceChange24h || 0;

  // If we have spawnMc and currentMc, prioritize calculating % gain from spawn
  if (spawnMc && spawnMc > 0 && currentMc && currentMc > 0) {
    pct = ((currentMc - spawnMc) / spawnMc) * 100;
  }

  if (!pct || pct === 0 || !Number.isFinite(pct)) return null;

  const isPositive = pct > 0;
  
  return (
    <span className={`inline-flex items-center gap-0.5 ml-1.5 font-mono font-bold ${isPositive ? 'text-emerald-400' : 'text-rose-400'} drop-shadow-md`}>
      {isPositive ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
      {isPositive ? '+' : ''}{Math.abs(pct) > 1000 ? (Math.abs(pct) / 1000).toFixed(1) + 'k' : Math.abs(pct).toFixed(1)}%
    </span>
  );
}
